import { useCallback } from "react";
import { createTrackingUtils } from "../index";
import useRouteName from "../../../hooks/useRouteName";

const util = createTrackingUtils({
  name: "flights_web_checkout_error_redirect",
  defaultStage: 1,
  stages: {
    main: 1,
    start: 2,
    ticket: 3,
    fare: 4,
    pax: 5,
    extras: 6,
    seat: 7,
    sirf: 8,
    payment: 9
  },
  goals: {}
});

export default function useFlightsWebCheckoutErrorRedirect() {
  const routeName = useRouteName();

  const track = useCallback(() => {
    util.stages.main();
    if (routeName === "checkout-start") util.stages.start();
    if (routeName === "checkout-ticket-type") util.stages.ticket();
    if (routeName === "checkout-fare") util.stages.fare();
    if (routeName === "checkout-pax") util.stages.pax();
    if (routeName === "checkout-extras") util.stages.extras();
    if (routeName === "checkout-seat-selection") util.stages.seat();
    if (routeName === "checkout-sirf") util.stages.sirf();
    if (routeName === "checkout-payment") util.stages.payment();
    return !!util.trackWithDefaultStage();
  }, [routeName]);
  return { track };
}
